import { Card, Col, Divider, Row, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import DashboardCard from '../../components/DashboardCard';
import TaskOverview from '../../components/TaskOverview';
import TaskTable from '../../components/TaskTable';
import { getManagerRestaurantsAnalytics } from '../../redux/actions/restaurant';

import { FiGrid } from 'react-icons/fi';
import { FiActivity } from 'react-icons/fi';
import { FiCheckCircle } from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const ManagerDashboard = () => {
  const [analytics, setAnalytics] = useState({});

  const KPIs = [
    {
      title: 'Total Tasks',
      value: analytics?.analytics?.total_tasks ?? 0,
      icon: <FiGrid />,
    },
    {
      title: 'Pending Tasks',
      value: analytics?.analytics?.pending_tasks ?? 0,
      status: 'warning',
      icon: <FiActivity />,
    },
    {
      title: 'Completed Tasks',
      value: analytics?.analytics?.completed_tasks ?? 0,
      status: 'success',
      icon: <FiCheckCircle />,
    },
    {
      title: 'Overdue Tasks',
      value: analytics?.analytics?.overdue_tasks ?? 0,
      status: 'danger',
      icon: <FiAlertTriangle />,
    },
  ];

  const taskData = [
    { category: 'Pending', count: Number(analytics?.analytics?.pending_tasks ?? 0) },
    { category: 'Completed', count: Number(analytics?.analytics?.completed_tasks ?? 0) },
    { category: 'Overdue', count: Number(analytics?.analytics?.overdue_tasks ?? 0) },
  ];

  useEffect(() => {
    const analytics = async () => {
      const res = await getManagerRestaurantsAnalytics();
      if (res?.ack) setAnalytics(res.data);
    };
    analytics();
  }, []);

  return (
    <>
      <Typography.Title level={3}>Manager Dashboard</Typography.Title>
      <Divider />
      <Row gutter={[16, 16]}>
        {KPIs.map((kpi) => (
          <Col key={kpi.title} xs={12} sm={12} md={12} lg={6}>
            <DashboardCard
              {...kpi}
            />
          </Col>
        ))}
      </Row>

      <Row gutter={[16, 16]} style={{ marginBlock: 24 }}>
        <Col xs={24} lg={14}>
          <Card title="Recent Tasks">
            <TaskTable data={analytics?.recent_tasks} />
          </Card>
        </Col>
        <Col xs={24} lg={10}>
          <TaskOverview
            title="Task Overview"
            data={taskData}
            total={analytics?.analytics?.total_tasks ?? 0}
          />
        </Col>
      </Row>
    </>
  );
};

export default ManagerDashboard;
